export default __webpack_public_path__ + "static/media/NMC_7.57c980c1.svg";